/* eslint-disable import/prefer-default-export */
import axios from 'axios'
// eslint-disable-next-line import/no-extraneous-dependencies
import MockAdapter from 'axios-mock-adapter'
import Cookies from 'js-cookie'
import AxiosInterceptor from '../hooks/AxiosInterceptorHook'
import {apiURLs, AddPDPCookie, } from './Utility'

import { getCsrfToken as getStoredCsrfToken } from './csrfToken'

const csrfCookieNames = ['XSRF-TOKEN', 'CSRF-TOKEN', 'X-CSRF-TOKEN']

const getCsrfToken = () => {
  const storedToken = getStoredCsrfToken()
  if(storedToken) {
    return storedToken
  }
  for(let i = 0; i < csrfCookieNames.length; i += 1) {
    const token = Cookies.get(csrfCookieNames[i])
    if(token) {
      return token
    }
  }
  return null
}

const withCsrfHeader = (request = {}) => {
  const method = (request.method || 'GET').toUpperCase()
  if(!['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    return request
  }

  const csrfToken = getCsrfToken()
  if(!csrfToken) {
    return Promise.reject(new Error('CSRF token not found. Unable to send request.'))
  }

  return {
    ...request,
    headers: {
      ...(request.headers || {}),
      'X-CSRF-Token': csrfToken,
      'X-XSRF-TOKEN': csrfToken
    }
  }
}

/**
 * Custome axios instance for usermanager api
 * @param {string} companyId
 * @param {string} iPlanetDirectoryProCookie
 * @param {string} bearerToken
 */
// defaults for bearer token and planetprocookie are set in loginHook
// after call to logLogin
const createTMSyncDataAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: `${apiURLs.transactionMiddlewareBaseUrl}`,
    headers: {
      'Content-Type': 'application/json'
    },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    withCredentials: true,
    timeout: 0

  })

  AddPDPCookie(axiosInstance)
  axiosInstance.interceptors.request.use(withCsrfHeader)

  const interceptor = AxiosInterceptor(axiosInstance)

  return {axiosInstance, interceptor}
}

const TMSyncDataAxiosInstance = createTMSyncDataAxiosInstance()



export default {

    getTMSyncData: (source,destination, wkstId, wkstProfile, cacheRefresh, wkstIds) => {

    // eslint-disable-next-line no-underscore-dangle
    if (window._env.TMSYNC_DATA) {

      // This sets the mock adapter on the default instance
      const mock = new MockAdapter(axios);

      // Mock any GET request to /users
      // arguments for reply are (status, data, headers)
      mock.onGet("/").reply(200,
        // eslint-disable-next-line no-underscore-dangle
        window._env.TMSYNC_DATA
      );

      return axios.get("/")
    }

    // const params = wkstId ? {wkstId} : null
    const params = {
      ...(wkstId && { wkstId }),
      ...(wkstIds?.length > 0 && { wkstIds: wkstIds.join(',') }),
      ...(wkstProfile && { wkstProfile })
    }

    return TMSyncDataAxiosInstance.axiosInstance({
      method: 'GET',
      params,
      url: `/sync/${source}/${destination}`
    })

  },
  sync: (source,destination, wkstId,wkstProfile, wkstIds) => {

    if (window._env.TMSYNC_DATA) {

      // This sets the mock adapter on the default instance
      const mock = new MockAdapter(axios);

      // Mock any GET request to /users
      // arguments for reply are (status, data, headers)
      mock.onPost("/").reply(200,
        // eslint-disable-next-line no-underscore-dangle
        window._env.TMSYNC_DATA
      );

      return axios.post("/")
    }

    const params = {
      ...(wkstId && { wkstId }),
      ...(wkstIds?.length > 0 && { wkstIds: wkstIds.join(',') }),
      ...(wkstProfile && { wkstProfile })
    }

    return TMSyncDataAxiosInstance.axiosInstance({
      method: 'POST',
      params,
      url: `/sync/${source}/${destination}`
    }
    )
  },
  sync: (source, destination, wkstId, wkstProfile, wkstIds) => {
    // This endpoint is deprecated - use sync with polling instead
    // Kept for backwards compatibility but should not be used
    const params = {
      ...(wkstId && { wkstId }),
      ...(wkstIds?.length > 0 && { wkstIds: wkstIds.join(',') }),
      ...(wkstProfile && { wkstProfile }),
      async: true
    }
    return TMSyncDataAxiosInstance.axiosInstance({
      method: 'POST',
      params,
      url: `/sync/${source}/${destination}`
    })
  },
  getSyncJobStatus: (jobId, timeout) => {
    return TMSyncDataAxiosInstance.axiosInstance({
      method: 'GET',
      url: `/sync/jobs/${jobId}`,
      params: timeout ? { timeout } : undefined,
      timeout: timeout || 0
    })
  },
  cancelSyncJob: (jobId) => {
    return TMSyncDataAxiosInstance.axiosInstance({
      method: 'POST',
      url: `/sync/jobs/${jobId}/cancel`
    })
  },
  syncWithProgressPolling: (source, destination, wkstId, wkstProfile, wkstIds) => {
    const params = {
      ...(wkstId && { wkstId }),
      ...(wkstIds?.length > 0 && { wkstIds: wkstIds.join(',') }),
      ...(wkstProfile && { wkstProfile }),
      async: true
    }
    const queryString = new URLSearchParams(params).toString()
    return `${TMSyncDataAxiosInstance.axiosInstance.defaults.baseURL}/sync/${source}/${destination}?${queryString}`
  },
  setJwtToken: jwtToken => {
    TMSyncDataAxiosInstance.axiosInstance.defaults.headers.common.Authorization = `Bearer ${jwtToken}`
  },

  setRequestInterceptor: (interceptor) => {
    TMSyncDataAxiosInstance.interceptor.setRequestInterceptor(interceptor)
  },
  setResponseInterceptor: (interceptor) => {
    TMSyncDataAxiosInstance.interceptor.setResponseInterceptor(interceptor)
  },

  ready: () => {
    return (TMSyncDataAxiosInstance.axiosInstance
      && TMSyncDataAxiosInstance.axiosInstance.defaults
      && TMSyncDataAxiosInstance.axiosInstance.defaults.headers
      && TMSyncDataAxiosInstance.axiosInstance.defaults.headers.common
      && TMSyncDataAxiosInstance.axiosInstance.defaults.headers.common.Authorization
      && true)
  }
}

